import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import {
  BtnPurpleTransparent32,
  BtnGreen32,
  TextField
} from 'components/common/Elements/Elements';

import classes from './RenameRadector.module.scss';

const RenameRadector = ({ className, onCancel, onClickOk }) => {
  const language = useUserState().user.language;

  const [editName, setEditName] = useState('');

  const onChangeName = e => {
    setEditName(e.target.value);
  };

  return (
    <div className={cn(classes.renameRedactor, className)}>
      <div className={cn(classes.inputBox)}>
        <div className={classes.inputWrap}>
          <TextField
            className={classes.inputWrap}
            classNameForInput={classes.input}
            value={editName}
            onChange={onChangeName}
            placeholder={t('textRedactor', 'NAME', language)}
          />
        </div>
      </div>

      <div className={classes.buttonBox}>
        <BtnPurpleTransparent32
          onClick={onCancel}
          textButton={t('textRedactor', 'CANCEL', language)}
          className={classes.buttonCancel}
        />

        <BtnGreen32
          disabled={editName.length > 0 ? false : true}
          onClick={() => onClickOk(editName)}
          textButton={t('textRedactor', 'SAVE', language)}
        />
      </div>
    </div>
  );
};

RenameRadector.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onClickOk: PropTypes.func.isRequired
};

export default RenameRadector;
